import { render } from "./ProjectRecurrenceFields.vue?vue&type=template&id=23e292e7"
import script from "./ProjectRecurrenceFields.vue?vue&type=script&lang=js"
export * from "./ProjectRecurrenceFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__